var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSjSvalbardandJanMayen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#EF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.125 0H31.875V45H43.125V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 16.875H0V28.125H60V16.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 0H34.6875V45H40.3125V0Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 19.6875H0V25.3125H60V19.6875Z",
    fill: "#002868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSjSvalbardandJanMayen);
export default __webpack_public_path__ + "static/media/sj Svalbard and Jan Mayen.1360e4036cc043c53ddebc068468af61.svg";
export { ForwardRef as ReactComponent };